/**
 * O ESQUELETO DO CARREGAMENTO (23/10/2026, item 9 da auditoria 3): enquanto a lista não chega, a FORMA dela (cartões cinza
 * pulsando), no lugar do indicador girando ou de "Carregando…". A tela não pula quando os dados chegam, e quem olha sabe o
 * que vem. `rotulo` vai para quem usa leitor de tela.
 */
export function EsqueletoDeCartoes({ quantos = 3, rotulo = 'Carregando…', comTitulo = true }: { quantos?: number; rotulo?: string; comTitulo?: boolean }) {
  return (
    <div className="animate-pulse space-y-4" role="status" aria-label={rotulo} data-testid="esqueleto">
      {comTitulo && <div className="h-7 w-48 rounded bg-gray-200" />}
      {Array.from({ length: quantos }).map((_, i) => (
        <div key={i} className="rounded-lg border border-gray-100 bg-white p-4 shadow-sm">
          <div className="h-5 w-3/4 rounded bg-gray-200" />
          <div className="mt-3 h-4 w-1/2 rounded bg-gray-100" />
          <div className="mt-2 h-4 w-2/3 rounded bg-gray-100" />
          <div className="mt-4 flex gap-2">
            <div className="h-9 w-24 rounded-md bg-gray-200" />
            <div className="h-9 w-24 rounded-md bg-gray-100" />
          </div>
        </div>
      ))}
      <span className="sr-only">{rotulo}</span>
    </div>
  );
}

/** Para painéis de números (relatórios): quatro blocos em grade. */
export function EsqueletoDeNumeros({ rotulo = 'Carregando…' }: { rotulo?: string }) {
  return (
    <div className="animate-pulse grid grid-cols-2 gap-4 md:grid-cols-4" role="status" aria-label={rotulo} data-testid="esqueleto">
      {Array.from({ length: 4 }).map((_, i) => (
        <div key={i} className="rounded-lg bg-white p-4 shadow-sm"><div className="h-4 w-20 rounded bg-gray-100" /><div className="mt-3 h-7 w-12 rounded bg-gray-200" /></div>
      ))}
    </div>
  );
}
